import { MarketingShell } from "@/components/landing/MarketingShell";
import { IntegrationsPage } from "@/components/integrations/IntegrationsPage";
import { SeoHead } from "@/components/useSeo";

const Page = () => (
  <MarketingShell>
    <SeoHead
      path="integrations"
      title="Integrations — DollarDeploy"
      description="The frameworks, cloud providers, notification channels, AI assistants and databases DollarDeploy works with."
    />
    <IntegrationsPage />
  </MarketingShell>
);

export default Page;
